{
    "raporrandevu": {
        "Baslik": "Randevu Raporu",
        "Tarih": "Tarih",
        "Kullanici": "Kullanıcı",
        "Musteri": "Müşteri",
        "Sonuc": "Sonuç",
        "Gorusme": "Görüşme",
        "Aciklama": "Açıklama",
        "Saat": "Saat",
        "Arama": "Arama",
        "Ara": "Ara",
        "Kapat": "Kapat",
        "Temizle": "Temizle",
        "BaslangicTarihi": "Başlangıç Tarihi",
        "BitisTarihi": "Bitiş Tarihi",
        "BasSaat": "Baş Saat",
        "BitSaat": "Bit Saat",
        "TGorusme": "T. Görüşme",
        "Ulasim": "Ulaşım",
        "Not": "Not",
        "Gorusme1": "İlk Görüşme",
        "Gorusme2": "2. Görüşme",
        "Arac": "Araç",
        "Diger": "Diğer",
        "OjtVar": "OJT Var",
        "OjtYok": "OJT Yok",
        "Harita": "Harita",
        "Duzenle": "Düzenle",
        "Sil": "Sil",
        "EminMisiniz": "Emin misiniz?",
        "GeriAlamazsiniz": "Bunu geri alamazsınız!",
        "EvetSil": "Evet, sil!",
        "Iptal": "İptal",
        "OjtBaslik": "On The Jobtraining",
        "OjtDegerlendirme": "Değerlendirme",
        "OjtOlustur": "Evet, oluştur!",
        "Sayfa": "Sayfa",
        "RandevuDetayi": "Randevu Detayı",
        "Katilanlar": "Katılanlar",
        "GecmisRandevular": "Geçmiş Randevular",
        "Konum": "Konum",
        "Vazgec": "Vazgeç",
        "Bilgisi": "Bilgisi",
        "EskiRandevular": "E.Randevular",
        "BaslamaSaat": "Başlama Saat",
        "BitisSaat": "Bitiş Saat",
        "GorusmeSonucu": "Görüşme Sonucu",
        "SonIslemYapan": "Son İşlem Yapan",
        "SonGuncelleme": "Son Güncelleme",
        "Guncelle": "Güncelle",
        "SaatKontrol": "Saat Kontrol",
        "Katilan": "Katılan",
        "Durum": "Durum",
        "Onay": "Onay",
        "Onayladi": "Onayladı",
        "Onaylamadi": "Onaylamadı",
        "Kapsam": "Kapsam",
        "Kendi": "Kendi",
        "Takim": "Takım",
        "Sube": "Şube",
        "Tam": "Tam",
        "HedeflenenRandevular": "Hedeflenen Randevular",
        "Islemler": "İşlemler",
        "OjtOlusurmaTooltip": "On The Jobtraining Oluşturma",
        "HaritaTooltip": "Harita",
        "GoruntuleTooltip": "Görüntüle",
        "SilTooltip": "Sil",
        "SilmeOnayMetni": "Bu işlem geri alınamaz. Kaydı kalıcı olarak silmek istediğinize emin misiniz?",
        "Excel": "Excel",
        "Ojt": "OJT"
    }
}
